import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// Config por defecto al activar la leyenda por primera vez (el gestor está optando in).
// null en el mapa => leyenda por defecto de siempre (retrocompatible); este objeto solo
// se usa como punto de partida cuando el gestor abre el panel sin config previa.
export function defaultLegendConfig(): any {
  return {
    defaultOpen: false,
    states: {
      available: { show: true, label: 'Disponible' },
      selected: { show: true, label: 'Seleccionada' },
      occupied: { show: true, label: 'No disponible' },
    },
    levels: { show: true, label: 'Zonas de precio' },
    blockedGroups: { show: true, label: 'Reservado' },
  };
}

@Component({
  selector: 'app-legend-config',
  templateUrl: './legend-config.component.html',
  styleUrls: ['./legend-config.component.scss']
})
export class LegendConfigComponent implements OnInit {

  // Objeto de configuración editable en el formulario.
  config: any = defaultLegendConfig();
  // Niveles vivos del mapa, solo para previsualizar en qué se expandirá "Zonas de precio".
  levels: any[] = [];
  // Indica si el mapa ya tenía leyenda personalizada al abrir el panel.
  hadConfig: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<LegendConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    this.levels = this.data?.levels || [];
    if (this.data?.legendConfig) {
      this.hadConfig = true;
      // Fusionar con los defaults para tolerar configs antiguas/incompletas.
      const base = defaultLegendConfig();
      const saved = this.data.legendConfig;
      this.config = {
        defaultOpen: !!saved.defaultOpen,
        states: {
          available: { ...base.states.available, ...(saved.states?.available || {}) },
          selected: { ...base.states.selected, ...(saved.states?.selected || {}) },
          occupied: { ...base.states.occupied, ...(saved.states?.occupied || {}) },
        },
        levels: { ...base.levels, ...(saved.levels || {}) },
        blockedGroups: { ...base.blockedGroups, ...(saved.blockedGroups || {}) },
      };
    }
  }

  // Guardar: devuelve la config al canvas (se persiste al guardar el mapa).
  confirm() {
    this.dialogRef.close({ confirmed: true, legendConfig: this.config });
  }

  // Desactivar la leyenda personalizada => vuelve a la leyenda por defecto (null).
  reset() {
    this.dialogRef.close({ confirmed: true, legendConfig: null });
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
